const GTM_ID_BY_URL = {
    'https://(lowes|lowesime).ee.inscyth.com': 'GTM-WZQG729',
    '.*': 'GTM-52LDQ5R',
};

export default GTM_ID_BY_URL;
